document.addEventListener('DOMContentLoaded', function () {
  const path = window.location.pathname;

  const allowedPage =
    path === '/' ||
    path.startsWith('/pages/') ||
    path.startsWith('/collections/');

  if (!allowedPage) return;

  const productCache = {};

  const productLinks = document.querySelectorAll(
    'a[href="/products/1-lb-of-essiac-blended-herbs"],' +
    'a[href="/products/1-lb-of-essiac-blended-herbs-in-four-4-4-oz-packets"],' +
    'a[href="/products/1-lb-2-oz-of-essiac-blended-herbs-in-eighteen-18-1-oz-packets"],' +
    'a[href="/products/3-lb-4-oz-of-essiac-blended-herbs-in-thirteen-13-4-oz-packets"]'
  );

  const petPagePaths = [
    '/pages/essiac-and-pets',
    '/pages/essiac-tea-for-dogs-your-complete-guide',
    '/pages/essiac-tea-for-cats-your-complete-guide',
    '/pages/your-guide-to-using-essiac-tea-for-horses'
  ];

  const isPetPage = petPagePaths.some(function (petPath) {
    return path === petPath;
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Product request failed: ' + response.status);
          }

          return response.json();
        });
    }

    return productCache[handle];
  }

  function replaceTextInElement(element, oldText, newText) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;

    while ((node = walker.nextNode())) {
      if (
        node.nodeValue &&
        node.nodeValue.indexOf(oldText) !== -1
      ) {
        node.nodeValue = node.nodeValue.replace(oldText, newText);
      }
    }
  }

  function removeOldStaticPrice(link) {
    const paragraphs = link.querySelectorAll('p');

    paragraphs.forEach(function (paragraph) {
      const text = paragraph.textContent.trim();
      const style = paragraph.getAttribute('style') || '';

      if (
        /^\$\d/.test(text) &&
        style.indexOf('#2c6e3f') !== -1
      ) {
        paragraph.remove();
      }
    });
  }

  function getDurationText(handle) {
    if (
      handle === '1-lb-of-essiac-blended-herbs' ||
      handle === '1-lb-of-essiac-blended-herbs-in-four-4-4-oz-packets'
    ) {
      return 'Lasts 2–3 months';
    }

    if (
      handle ===
      '3-lb-4-oz-of-essiac-blended-herbs-in-thirteen-13-4-oz-packets'
    ) {
      return 'Lasts 6–9 months';
    }

    return null;
  }

  productLinks.forEach(function (link) {
    const href = link.getAttribute('href');

    if (!href) return;

    const handle = href.split('/products/')[1];

    if (!handle) return;

    fetchProduct(handle)
      .then(function (product) {
        const variant =
          product.variants &&
          product.variants[0];

        if (!variant) return;

        const button = link.querySelector(
          'div[style*="background: #2c6e3f"]'
        );

        if (!button) return;

        /*
         * Remove old manually entered green prices
         * from pet cards.
         */
        removeOldStaticPrice(link);

        /*
         * Update Best Value heading.
         */
        if (
          handle ===
          '3-lb-4-oz-of-essiac-blended-herbs-in-thirteen-13-4-oz-packets'
        ) {
          replaceTextInElement(
            link,
            'Most Popular Best Value Pack:',
            'Most Popular & Great Value'
          );

          replaceTextInElement(
            link,
            'Most Popular Best Value Pack',
            'Most Popular & Great Value'
          );

          replaceTextInElement(
            link,
            'Most Popular & Best Value',
            'Most Popular & Great Value'
          );
        }

        /*
         * Automatic SALE badge.
         * Only appears when compare-at price
         * is higher than the current price.
         */
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price &&
          !link.querySelector('.dynamic-product-card-sale-badge')
        ) {
          const saleBadge = document.createElement('div');

          saleBadge.className =
            'dynamic-product-card-sale-badge';

          saleBadge.textContent = 'SALE';

          link.insertBefore(
            saleBadge,
            link.firstChild
          );
        }

        /*
         * Add "Lasts..." line to regular cards only.
         * Do not display it on pet/dog/cat/horse pages.
         */
        if (
          !isPetPage &&
          !link.querySelector('.dynamic-product-card-duration')
        ) {
          const durationText = getDurationText(handle);

          if (durationText) {
            const duration =
              document.createElement('div');

            duration.className =
              'dynamic-product-card-duration';

            duration.textContent =
              durationText;

            button.parentElement.insertBefore(
              duration,
              button
            );
          }
        }

        /*
         * Do not insert dynamic pricing twice.
         */
        if (
          !link.querySelector(
            '.dynamic-product-card-price'
          )
        ) {
          const priceWrap =
            document.createElement('div');

          priceWrap.className =
            'dynamic-product-card-price';

          /*
           * Compare-at / sale price.
           */
          if (
            variant.compare_at_price &&
            variant.compare_at_price >
              variant.price
          ) {
            const compare =
              document.createElement('span');

            compare.className =
              'dynamic-product-card-compare';

            compare.textContent =
              formatMoney(
                variant.compare_at_price
              );

            compare.style.textDecoration =
              'line-through';

            compare.style.color = '#777';

            compare.style.marginRight =
              '8px';

            priceWrap.appendChild(compare);
          }

          /*
           * Current Shopify price.
           */
          const current =
            document.createElement('span');

          current.className =
            'dynamic-product-card-current';

          current.textContent =
            formatMoney(variant.price);

          priceWrap.appendChild(current);

          /*
           * Auto-Ship price.
           */
          const allocations =
            variant.selling_plan_allocations ||
            [];

          if (allocations.length > 0) {
            let lowestAutoship = null;

            allocations.forEach(
              function (allocation) {
                if (
                  allocation.per_delivery_price &&
                  (
                    lowestAutoship === null ||
                    allocation.per_delivery_price <
                      lowestAutoship
                  )
                ) {
                  lowestAutoship =
                    allocation.per_delivery_price;
                }
              }
            );

            if (lowestAutoship !== null) {
              const autoship =
                document.createElement('div');

              autoship.className =
                'dynamic-product-card-autoship';

              autoship.textContent =
                'Auto-Ship ' +
                formatMoney(lowestAutoship);

              priceWrap.appendChild(
                autoship
              );
            }
          }

          button.parentElement.insertBefore(
            priceWrap,
            button
          );
        }

        /*
         * 1 lb upsell link.
         * Uses a span because the whole product card
         * is already wrapped in an anchor.
         */
        if (
          handle === '1-lb-of-essiac-blended-herbs' &&
          !link.querySelector('.dynamic-product-card-upsell')
        ) {
          const upsell = document.createElement('span');

          upsell.className =
            'dynamic-product-card-upsell';

          upsell.setAttribute('role', 'link');
          upsell.setAttribute('tabindex', '0');

          upsell.textContent =
            'Get 4 bags for the price of 3 →';

          function openUpsell(event) {
            event.preventDefault();
            event.stopPropagation();

            window.location.href =
              '/products/4-lb-of-essiac-blended-herbs-in-four-4-1-lb-bags';
          }

          upsell.addEventListener(
            'click',
            openUpsell
          );

          upsell.addEventListener(
            'keydown',
            function (event) {
              if (
                event.key === 'Enter' ||
                event.key === ' '
              ) {
                openUpsell(event);
              }
            }
          );

          button.parentElement.insertBefore(
            upsell,
            button
          );
        }

        /*
         * Button state.
         */
        if (!variant.available) {
          button.textContent = 'Sold Out';
          button.style.opacity = '0.6';
        } else {
          button.textContent = 'Shop Now';
          button.style.opacity = '1';
        }
      })
      .catch(function (error) {
        console.error(
          'Dynamic CTA fetch failed:',
          handle,
          error
        );
      });
  });

  /*
   * Upsell styling.
   */
  if (!document.getElementById('dynamic-product-card-upsell-style')) {
    const upsellStyle =
      document.createElement('style');

    upsellStyle.id =
      'dynamic-product-card-upsell-style';

    upsellStyle.textContent = `
      .dynamic-product-card-upsell {
        display: block;
        margin: 10px 0 12px;
        font-size: 14px;
        font-weight: 700;
        color: #2c6e3f;
        text-decoration: none;
        border-bottom: 1px solid #2c6e3f;
        padding-bottom: 2px;
        text-align: center;
        cursor: pointer;
      }

      .dynamic-product-card-upsell:hover {
        opacity: 0.8;
      }

      .dynamic-product-card-upsell:focus {
        outline: 2px solid #2c6e3f;
        outline-offset: 3px;
      }

      @media screen and (max-width: 749px) {
        .dynamic-product-card-upsell {
          font-size: 13px;
          margin: 8px 0 10px;
        }
      }
    `;

    document.head.appendChild(
      upsellStyle
    );
  }
});